const PRODUCTION_APP_ORIGIN = "https://app.mindsherpa.health";
const GUIDANCE_PATH_PATTERN = /^\/exercises\/[A-Za-z0-9_-]+\/?$/;
const SHERPA_PATH_PATTERN = /^\/sherpa(?:\/session\/[A-Za-z0-9_-]+)?\/?$/;

export const getInternalGuidancePath = (
  href,
  currentOrigin = window.location.origin
) => {
  if (typeof href !== "string" || !href.trim()) return null;

  try {
    const currentUrl = new URL(currentOrigin);
    const targetUrl = new URL(href, currentUrl);
    const isSameOrigin = targetUrl.origin === currentUrl.origin;
    const isProductionApp = targetUrl.origin === PRODUCTION_APP_ORIGIN;

    if (!isSameOrigin && !isProductionApp) return null;
    if (!GUIDANCE_PATH_PATTERN.test(targetUrl.pathname)) return null;

    return targetUrl.pathname.replace(/\/$/, "");
  } catch {
    return null;
  }
};

export const getSherpaReturnPath = (state) => {
  const returnTo = state?.returnTo;

  if (typeof returnTo !== "string" || !SHERPA_PATH_PATTERN.test(returnTo)) {
    return null;
  }

  return returnTo.replace(/\/$/, "");
};
